// extracted by mini-css-extract-plugin
export default {"bannerRow":"TvBannerCarousel_bannerRow__F6Q2D","carousel":"TvBannerCarousel_carousel__-uQd1","track":"TvBannerCarousel_track__F8tVD","banner":"TvBannerCarousel_banner__yQZ1y"};